import * as React from 'react'
import Btn from 'src/shared/Btn/Btn'
import {withI18n, WithI18n} from 'src/core/i18n/withI18n'
import {compose} from 'redux'
import {ExpensionStepProps} from 'src/type/lib/ExpensionStep'
import autobind from 'autobind-decorator'

interface IProps extends WithI18n,
  ExpensionStepProps{
  canNext: boolean;
  onClick: () => void;
  loading: boolean;
}

class Actions extends React.Component<IProps, {}>{

  render(){
    const { index, prev, canNext, t, isLast, loading } = this.props;
    return (
      <div style={{marginTop: 16, display: 'flex', justifyContent: 'flex-end'}}>
        {(index && index > 0) ?
          <Btn
            color='primary'
            onClick={prev}
            disabled={loading}
          >{t.previous}</Btn> : null
        }
        <Btn
          color='primary'
          variant='contained'
          onClick={this.onNext}
          disabled={!canNext}
          loading={loading}
        >{isLast ? t.terminate : t.next}</Btn>
      </div>
    )
  }

  @autobind
  private onNext(){
    if(this.props.onClick){
      this.props.onClick();
    }
    if(this.props.next) this.props.next();
  }

}

export default compose(
  withI18n
)(Actions);



// WEBPACK FOOTER //
// ./src/page/ValidationTunnel/Actions.tsx